import { render } from "./BMICalculationItemHeight.vue?vue&type=template&id=4731e986&ts=true"
import script from "./BMICalculationItemHeight.vue?vue&type=script&lang=ts"
export * from "./BMICalculationItemHeight.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__